import { useEffect, useRef, useState } from "react";

const LOG_LERP_SPEED = 0.18;
const SNAP_THRESHOLD = 1;

export function useAnimatedValue(target: number): number {
  const [display, setDisplay] = useState(target);
  const currentRef = useRef(target);
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const animate = () => {
      const current = currentRef.current;
      if (Math.abs(current - target) < SNAP_THRESHOLD) {
        currentRef.current = target;
        setDisplay(target);
        return;
      }

      let next: number;
      if (current > 0 && target > 0) {
        const logCurrent = Math.log(current);
        const logTarget = Math.log(target);
        next = Math.exp(logCurrent + (logTarget - logCurrent) * LOG_LERP_SPEED);
      } else {
        next = current + (target - current) * LOG_LERP_SPEED;
      }

      currentRef.current = next;
      setDisplay(Math.round(next));
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target]);

  return display;
}
